export const groupBy = <S, K>(source: S[], keySelector: (sourceItem: S, index?: number) => K): Map<K, S[]> => {
	const groups = new Map<K, S[]>();
	source.forEach((item, index) => {
		const key = keySelector(item, index);
		const group = groups.get(key) || ([] as S[]);
		group.push(item);
		groups.set(key, group);
	});
	return groups;
};
